/*!
 * beAdminUsers Jquery plugin:
 * Plugin para la selección de usuarios del back
 * Author: @pablocrs
 */

;(function ($, window, document, undefined) {


    // Create the defaults once
    var pluginName = 'beAdminUsers',
        defaults = {
            selectAdminUsers: "#beAdminUsers-select",
            apiUrl: window.location.origin,
            locale: 'es'
        };

    // The actual plugin constructor
    function Plugin(element, options) {
        this.element = element;
        this.$element = $(element);

        this.options = $.extend({}, defaults, options);

        this._defaults = defaults;
        this._name = pluginName;

        this.selects = [
            this.$element.find(this.options.selectAdminUsers)
        ];

        this.init();
    }

    Plugin.prototype.init = function () {
        var Plugin = this;

        Plugin.setEvents();
        Plugin.loadSelect(Plugin.selects[0]);

        Plugin.getLocale();

        Plugin.selects[0].on('change', function () {
            Plugin.clearAll();
            $.each(Plugin.selects, function (i, select) {
                if (i > 0) {
                    Plugin.selects[i].val('null').empty().trigger('change');
                }
            });
        });

        Plugin.selects[0].on('select2:unselect', function () {
            Plugin.clearAll();
            $.each(Plugin.selects, function (i, select) {
                Plugin.selects[i].val('null').empty().trigger('change');
            });
        });

        $.each(Plugin.selects, function (i, select) {
            if (i > 0) {
                if (!Plugin.selects[i].val()) {
                    Plugin.selects[i].prop('disabled', true).select2('data', null);
                }
            }
        });
    };

    /// Recoge el locale activo
    //
    Plugin.prototype.getLocale = function () {
        var Plugin = this;

        var localePath = $(location).attr('pathname');

        localePath.indexOf(1);
        localePath.toLowerCase();
        localePath = localePath.split("/")[1];

        if (localePath === 'en') {
            Plugin.options.apiUrl = window.location.origin + '/' + localePath;
            Plugin.options.locale = 'en';
        }
    };

    /// Carga paises en el primer select
    //
    Plugin.prototype.loadSelect = function (select) {
        var Plugin = this;


        var url = Plugin.options.apiUrl + '/admin/list-select';
        var enabledInactives = select.data("inactives");

        if (enabledInactives === true) {
            url += '?activated=0';
        }

        select.select2('data', null);

        select.select2({
            allowClear: true,
            ajax: {
                url: url,
                dataType: 'json',
                delay: 250,
                method: 'GET',
                async: false,
                data: function (params) {
                    return {
                        search: {name: params.term}, // search term
                        page: params.page
                    };
                },
                processResults: function (data, params) {

                    params.page = params.page || 1;

                    if (data.data) {
                        return {
                            results: $.map(data.data, function (item) {
                                return {
                                    text: item.first_name + ' ' + item.last_name,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 30) < data.total
                            }
                        };
                    }
                    else {
                        return {
                            results: $.map(data, function (item) {
                                return {
                                    text: item.first_name,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 30) < data.total_count
                            }
                        };
                    }
                },
                cache: true
            }
        });

        if (select.data('selected')) {
            select.val(select.data('selected')).trigger('change');
        }
    };

    // Congfigura evento change en cada select
    //
    Plugin.prototype.setEvents = function () {
        var Plugin = this;
    };

    Plugin.prototype.clearAll = function () {
        $.each(Plugin.selects, function (i, select) {
            if (i > 0) {
                Plugin.selects[i].select2('data', null);
                Plugin.selects[i].val(null).trigger('change');
                if (!Plugin.selects[i].val()) {
                    Plugin.selects[i].prop('disabled', true);
                }
            }
        });
    };

    // A really lightweight plugin wrapper around the constructor,
    // preventing against multiple instantiations
    $.fn[pluginName] = function (options) {
        return this.each(function () {
            if (!$.data(this, 'plugin_' + pluginName)) {
                $.data(this, 'plugin_' + pluginName,
                    new Plugin(this, options));
            }
        });
    }

})(jQuery, window, document);